<template>
  <el-dialog
      :title="`${docInfo.hosName}处方笺`"
      :visible.sync="preDialogVisible"
      :append-to-body='true'
      width="500px"
      center>
    <div class="recipe-preview">
      <p class="right bb pb10 mb10">
        <span v-if="recipeInfo.orderNo">处方编号：{{ recipeInfo.orderNo }}</span>
      </p>
      <renewal-drug-info
          :isPreview="true"
          :info="Object.assign({}, recipeInfo, {_hisCreateTime: currDate})"
          :list="drugList"></renewal-drug-info>
    </div>
    <span v-if="source==='EPrescription'" slot="footer" class="dialog-footer flex fs14">
            <el-button v-if="needSign" type="primary" @click="handler('去签名')" class="flex1">去 签 名</el-button>
            <el-button v-else type="primary" @click="handler('确认开方')" class="flex1">确认开方</el-button>
        </span>
  </el-dialog>
</template>

<script>
import RenewalDrugInfo from "../renewal/renewal-durg-info";
import {systemService} from "../../lib/service/system";
import {timeFormat} from "../../lib/utils";
import {loginInfoCache} from "../../lib/cache/LoginInfo";

export default {
  name: "recipe-preview",
  components: {RenewalDrugInfo},
  data() {
    return {
      needSign: false,
      preDialogVisible: false,
      recipeInfo: {
        orderType: "WESTERN_RECIPE", //中药西药
        compatName: '',
        _sex: '',
        compatAge: '',
        deptName: '',
        _hisCreateTime: 0, //开具日期
        dosageForm: '', //类型 中药 饮片或者颗粒
        docName: '',
        tcmDosage: '', //贴数 仅中药
        tcmAdmission: '' //用法 仅中药
      },
      patientInfo: {},
      drugList: [{
        admission: "口服，每日三次，每次一粒", //用法
        dosage: '', //单次剂量
        dosageForm: '',//中药 饮片、颗粒
        dosageUnit: '', //中药计量单位
        amount: 3, //
        createTime: 1571625215000,
        drugName: "阿莫西林胶囊", //
        drugOrigin: "杭州", //
        drugSpecification: "0.25*24", //
        drugTotalPrice: 3,
        drugUnit: "粒", //
        drugUnitPrice: 1, //
        id: "200106045441",
        orderId: "200106045440",
        remarks: "补充说明：注意饮食，多喝热水", //
        frequencyName: "", //使用频次 西药
        useDays: "" //用药天数  西药

      }],
    }
  },
  props: {
    info: Object,
    drugs: Array,
    source: String
  },
  computed: {
    currDate() {
      const tDate = new Date()
      return timeFormat(tDate, "%Y/%m/%d")
    },
  },
  methods: {
    async show() {
      let res = await systemService.key('RECIPE_NEED_SIGN')
      this.needSign = res === 'Y'
      this.preDialogVisible = true
    },
    hide() {
      this.preDialogVisible = false
    },
    handler(name, type) {
      this.preDialogVisible = false
      this.$emit('handler', name, type)
    },
  },
  watch: {
    info: {
      handler(newV) {
        this.recipeInfo = newV
      },
      immediate: true
    },
    patient: {
      handler(newV) {
        this.patientInfo = newV
      }
    },
    drugs: {
      handler(newV) {
        this.drugList = newV
      }
    }
  }
}
</script>

<style scoped lang="scss">
#el-drawer__title {
  padding: 0 !important;
  margin: 0 !important;
}

.recipe-preview {
  margin-top: -25px;
}
</style>
